<template lang="pug">
  v-app(id="app")
    v-navigation-drawer(v-if="showMenu" v-model="drawer" fixed app disable-resize-watcher)
      v-list(dense)
        v-list-tile.two-line-list-item(exact to="/")
          v-list-tile-content: img.logo(src="/assets/hvd-logo.svg")
        template(v-for="menu in mainMenus")
          v-list-group(value="true" v-if="menu.children.length")
            v-list-tile(slot="activator")
              v-list-tile-title {{menu.name}}
            template(v-for="item in menu.children")
              v-list-group(v-if="item.children.length" sub-group no-action)
                v-list-tile(slot="activator")
                  v-list-tile-title {{item.name}}
                v-list-tile(:to="item2.route" v-for="item2 in item.children" :key="item2.id")
                  v-list-tile-title {{item2.name}}
              v-list-tile(v-else sub-group :to="item.route")
                .mr-4.ml-1
                v-list-tile-title {{item.name}}
          template(v-else)
            v-list-tile(:to="menu.route"): v-list-tile-title {{menu.name}}
      v-list.mt-3.hidden-sm-and-up(dense)
        template(v-if="user && user.id")
            v-list-tile
              v-list-tile-avatar
                  img(v-if="user.avatar" :src="user.avatar")
                  v-icon(v-else) person
              v-list-tile-title {{user.name}}
            v-list
              v-list-tile(href="/admin")
                v-list-tile-avatar: v-icon tab
                v-list-tile-title Backend
              v-list-tile(to="/mein-profil")
                v-list-tile-avatar: v-icon person
                v-list-tile-title Mein Profil
              v-list-tile(to="/mein-projekt" v-if="userCanSeeProject")
                v-list-tile-avatar: v-icon home
                v-list-tile-title Mein Projekt
              v-list-tile(v-if="user.email_urlized" :href="`https://hvdbb-my.sharepoint.com/personal/${user.email_urlized}/_layouts/15/onedrive.aspx`")
                v-list-tile-avatar: v-icon cloud
                v-list-tile-title Meine Daten
              v-list-tile(@click="logout")
                v-list-tile-avatar: v-icon power_settings_new
                v-list-tile-title Ausloggen
        template(v-else)
          v-list-tile(href="/admin/auth/office365")
            v-list-tile-title Anmelden
    v-toolbar(v-if="showMenu" color="primary" dark fixed app)
      v-toolbar-side-icon.side-icon.hidden-md-and-up(@click.stop="drawer = !drawer")
      v-toolbar-items
        v-btn.logo-btn(flat exact to="/")
          img.logo(src="/assets/hvd-logo-white.svg")
      v-toolbar-items.hidden-sm-and-down
        template(v-for="(menu, iMenu) in mainMenus")
          v-menu(TODO-open-on-hover :value="isMenuOpen(iMenu)" @input="toggleMenu(iMenu, $event)" bottom offset-y v-if="menu.children.length")
            v-btn(flat slot="activator")
              | {{menu.name}}
              v-icon arrow_drop_down
            v-list
              template(v-for="item in menu.children")
                v-menu(open-on-hover right offset-x v-if="item.children.length")
                  v-list-tile(flat slot="activator" @click.stop="")
                    v-list-tile-title {{item.name}}
                    v-list-tile-action(style="justify-content: flex-end"): v-icon arrow_drop_down
                  v-list
                    v-list-tile(@click="toggleMenu(iMenu, false)" :to="item2.route" v-for="item2 in item.children" :key="item2.id")
                      v-list-tile-title {{item2.name}}
                v-list-tile(v-else @click="toggleMenu(iMenu, false)" :to="item.route"): v-list-tile-title {{item.name}}
          template(v-else)
            v-btn(flat :to="menu.route") {{menu.name}}

      v-spacer
      v-toolbar-items.hidden-xs-only
        template(v-if="user && user.id")
          v-menu(open-on-hover bottom offset-y)
            v-btn(flat slot="activator")
              v-avatar.mr-2
                img(v-if="user.avatar" :src="user.avatar")
                v-icon(v-else) person
              |  {{user.name}}
              v-icon arrow_drop_down
            v-list
              v-list-tile(href="/admin")
                v-list-tile-avatar: v-icon tab
                v-list-tile-title Backend
              v-list-tile(to="/mein-profil")
                v-list-tile-avatar: v-icon person
                v-list-tile-title Mein Profil
              v-list-tile(to="/mein-projekt" v-if="userCanSeeProject")
                v-list-tile-avatar: v-icon home
                v-list-tile-title Mein Projekt
              v-list-tile(v-if="user.email_urlized" :href="`https://hvdbb-my.sharepoint.com/personal/${user.email_urlized}/_layouts/15/onedrive.aspx`")
                v-list-tile-avatar: v-icon cloud
                v-list-tile-title Meine Daten
              v-list-tile(href="/arbeitszeugnis" v-if="authorized")
                v-list-tile-avatar: v-icon assignment
                v-list-tile-title Arbeitszeugnisgenerator
              v-list-tile(@click="logout")
                v-list-tile-avatar: v-icon power_settings_new
                v-list-tile-title Ausloggen
        template(v-else)
          v-btn(flat href="/admin/auth/office365") Anmelden

    router-view

</template>

<style lang="stylus" scoped>
.side-icon
  margin-right 20px

.two-line-list-item.two-line-list-item >>> a
  height 80px

.logo-btn >>> .v-btn__content
  height 100%

.logo
  padding 10px 0
  height 100%
  width auto

</style>

<script>
import { menus, user } from '../router'

function onlyVisible(menuItems) {
  return menuItems.filter(m => m.state === 'visible').map(i => {
    return { ...i, children: onlyVisible(i.children) }
  })
}

export default {
  props: {
    source: String
  },
  data: function () {
    return {
      drawer: false,
      user,
      menus,
      menuState: {},
    }
  },
  computed: {
    footerExtras() {
      return []
    },
    mainMenus() {
      return this.menus && this.menus.MainMenu && onlyVisible(this.menus.MainMenu.children || [] )
    },
    showMenu() {
      return !!(this.menus && this.menus.MainMenu)
    },
    userCanSeeProject() {
      return this.user && this.user.person && (this.user.person.vorstand || this.user.person.abteilungsleitung || this.user.person.bereichsleitung || this.user.person.projektleitung || this.user.person.ticketBearbeiter)
    },
    authorized() {
      return this.user && (this.user.roles.indexOf('arbeitszeugnis') > -1)
    }
  },
  methods: {
    isMenuOpen(iMenu) {
      return this.menuState[iMenu]
    },
    toggleMenu(iMenu, open) {
      this.$set(this.menuState, iMenu, open)
    },
    logout() {
      this.$http.delete('/admin/logout').then(response => {
        this.$apollo.provider.defaultClient.resetStore()
        location = '/'
      })
    }
  }
}
</script>
